import React from "react";

import { LinkContainer } from "react-router-bootstrap";
import { Button } from "react-bootstrap";
import { MenuItem } from "../../../datatypes/MenuItem";

type Props = {
    menuItemLink: MenuItem;
};

function MenuItemLink(props: Props) {
    const item = props.menuItemLink;
    let classNameButton;
    let classNameSpan;
    if (item.id === "orders") {
        classNameButton = "test-ex-myorders-navbar-global-header";
        classNameSpan = "hidden-sm";
    } else if (item.id === "lists") {
        classNameButton = "test-ex-mylists-navbar-global-header";
        classNameSpan = "hidden-sm";
    } else {
        classNameButton = "";
        classNameSpan = "";
    }
    if (item.relativeURL) {
        return (
            <LinkContainer to={{ pathname: item.relativeURL }}>
                <Button className={classNameButton}>
                    {item.iconName && <i className={"icon-lg " + item.iconName} />}
                    <span className={classNameSpan}>{item.name}</span>
                </Button>
            </LinkContainer>
        );
    } else {
        return (
            <div className="btn-group">
                <a href={item.absoluteURL!} className="btn-default btn">
                    <span className={classNameSpan}>{item.name}</span>
                </a>
            </div>
        );
    }
}

export default MenuItemLink;
